import { __extends } from "tslib";
import { AssetBase, PerspectiveProjection, CoordinateSystem, Transform, Vector3D, } from '@awayjs/core';
import { View } from '../View';
/**
 * @class away.partition.Partition
 */
var PartitionBase = /** @class */ (function (_super) {
    __extends(PartitionBase, _super);
    function PartitionBase(rootNode) {
        var _this = _super.call(this) || this;
        _this._children = new Array();
        _this._updateQueue = {};
        _this._rootNode = rootNode;
        return _this;
    }
    Object.defineProperty(PartitionBase.prototype, "parent", {
        get: function () {
            return this._parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PartitionBase.prototype, "rootNode", {
        get: function () {
            return this._rootNode;
        },
        enumerable: false,
        configurable: true
    });
    PartitionBase.prototype.getLocalNode = function () {
        if (!this._localNode) {
            /**
            * projection is not simple object
            * not needed spawn it for every cached partition
            * it has 3 matrices = 100 bytes + Transform,
            * that have 4 matrices + a lot of vectors (16 bytes) = 300 bytes,
            * And this is under heavy extending. 1 projection allocate more that 4kb per instance
            */
            var projection = PartitionBase._defaultProjection;
            if (!projection) {
                projection = new PerspectiveProjection();
                projection.coordinateSystem = CoordinateSystem.LEFT_HANDED;
                projection.originX = -1;
                projection.originY = -1;
                projection.transform = new Transform();
                projection.transform.moveTo(0, 0, -1000);
                projection.transform.lookAt(new Vector3D());
            }
            var view = new View(projection, this._rootNode.view.stage);
            view.backgroundAlpha = 0;
            this._localNode = view.getNode(this._rootNode.container);
            this._localNode.transformDisabled = true;
            this.addChild(this._localNode.partition);
        }
        return this._localNode;
    };
    PartitionBase.prototype.clearLocalNode = function () {
        if (this._localNode) {
            this.removeChild(this._localNode.partition);
            this._localNode.onClear(null);
            this._localNode = null;
        }
    };
    PartitionBase.prototype.addChild = function (child) {
        this._children.push(child);
        child.setParent(this);
        // this.updateNode(child.rootNode);
        this.invalidate();
    };
    PartitionBase.prototype.removeChild = function (child) {
        //child.clear();
        this._children.splice(this._children.indexOf(child), 1)[0];
        child.setParent(null);
        // this._rootNode.removeNode(child.rootNode);
        this.invalidate();
    };
    PartitionBase.prototype.setParent = function (parent) {
        this._parent = parent;
    };
    PartitionBase.prototype.traverse = function (traverser) {
        this._invalid = false;
        this._rootNode.acceptTraverser(traverser);
    };
    PartitionBase.prototype.invalidateEntity = function (entityNode) {
        this.invalidate();
        this._updateQueue[entityNode.id] = entityNode;
    };
    PartitionBase.prototype.updateEntity = function (entityNode) {
        //TODO: remove reliance on view
        //required for controllers with autoUpdate set to true and queued events
        entityNode.parent.container._iInternalUpdate();
        this.updateNode(entityNode);
    };
    PartitionBase.prototype.updateNode = function (node) {
        //const targetNode: ContainerNode = this.findParentForNode(node);
        // if (targetNode && node.parent != targetNode) {
        // 	if (node.parent)
        // 		node.parent.removeNode(node);
        // 	targetNode.addNode(node);
        // }
    };
    PartitionBase.prototype.clearEntity = function (entityNode) {
        this.invalidate();
        delete this._updateQueue[entityNode.id];
        // const node: INode = entity.getAbstraction<EntityNode>(this);
        // node.parent.removeNode(node);
    };
    /**
     *
     * @param entity
     * @returns {away.partition.NodeBase}
     */
    PartitionBase.prototype.findParentForNode = function (node) {
        return this._rootNode;
    };
    PartitionBase.prototype.updateEntities = function () {
        for (var key in this._updateQueue)
            this.updateEntity(this._updateQueue[key]);
        //clear updateQueue
        this._updateQueue = {};
    };
    PartitionBase.prototype.invalidate = function () {
        if (this._invalid)
            return;
        this._invalid = true;
        _super.prototype.invalidate.call(this);
        if (this._parent)
            this._parent.invalidate();
    };
    PartitionBase.prototype.clear = function () {
        _super.prototype.clear.call(this);
        if (this._localNode) {
            this._localNode.clear();
            this._localNode = null;
        }
    };
    PartitionBase.prototype.dispose = function () {
    };
    // public _setScene(scene: IPartitionEntity): void {
    // 	if (this._scene == scene)
    // 		return;
    // 	this._scene = scene;
    // 	const len: number = this._children.length;
    // 	for (let i: number = 0; i < len; ++i)
    // 		this._children[i]._setScene(scene);
    // }
    PartitionBase.prototype.requestAbstraction = function (asset) {
        return PartitionBase._abstractionClassPool[asset.assetType];
    };
    /**
     *
     * @param imageObjectClass
     */
    PartitionBase.registerAbstraction = function (abstractionClass, assetClass) {
        PartitionBase._abstractionClassPool[assetClass.assetType] = abstractionClass;
    };
    PartitionBase._abstractionClassPool = {};
    return PartitionBase;
}(AssetBase));
export { PartitionBase };
